import React from "react";

import Modal from "../../../components/dialogs/modal";

import { DiscountSelect } from "../DiscountSelect";
import { AddDiscountModalProps } from "./types";
import { useI18n } from "../../../hooks/useI18n";

const AddDiscountModal = ({
  visible,
  onOk,
  onCancel,
  onSelectDiscount
}: AddDiscountModalProps) => {
  const { t } = useI18n();
  return (
    <Modal
      title={t("common.actions.addCoupon")}
      open={visible}
      actions={[
        {
          text: "Add",
          type: "ok",
          action: onOk
        },
        {
          text: "Cancel",
          type: "cancel",
          action: onCancel
        }
      ]}
    >
      <div style={{ textAlign: "center" }}>
        <DiscountSelect
          onChange={value => onSelectDiscount(value.toString())}
        />
      </div>
    </Modal>
  );
};

export default AddDiscountModal;
